@if (bookingData()) {
<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div class="flex items-center gap-4 px-5 py-4">
        <button
          class="h-10 w-10 grid place-items-center rounded-2xl hover:bg-slate-50 active:scale-95 transition-all text-slate-700"
          (click)="toBack()">
          <span class="material-symbols-outlined text-slate-700">arrow_back</span>
        </button>
        <div class="flex-1">
          <h1 class="text-xl font-black text-slate-800 tracking-tight">{{ 'สรุปการจอง' | translate : 'booking-info' }}</h1>
          <p class="text-xs font-medium text-slate-500 mt-0.5">{{ 'ตรวจสอบรายละเอียดให้ถูกต้อง' | translate : 'booking-info' }}</p>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto w-full px-5 pt-5 pb-40 space-y-4">

      <!-- Hotel Card -->
      <div class="bg-white rounded-2xl border border-slate-200 overflow-hidden">

        <!-- Hotel name + badge -->
        <div class="p-4 flex items-start justify-between gap-3">
          <div class="min-w-0 flex-1">
            <div class="flex items-center gap-1.5 mb-1">
              <span class="material-symbols-outlined text-blue-400 text-[16px]">hotel</span>
              <span class="text-[11px] font-medium text-blue-500 uppercase tracking-wide">{{ 'ที่พัก' | translate : 'booking-info' }}</span>
            </div>
            <div class="text-base font-bold text-slate-900 leading-snug">{{bookingData().branchName}}</div>
            @if (bookingData().branchAddress) {
            <div class="mt-1 flex items-center gap-1">
              <span class="material-symbols-outlined text-[13px] text-slate-400 mt-0.5 shrink-0">location_on</span>
              <div class="text-xs text-slate-400 leading-4">{{bookingData().branchAddress}}</div>
            </div>
            }
          </div>
          <div class="shrink-0">
            <div
              class="inline-flex items-center gap-1 rounded-lg bg-amber-50 border border-amber-100 px-2 py-1 text-xs font-bold text-amber-600">
              <span class="material-symbols-outlined text-[13px] text-amber-400">star</span>
              <span>5</span>
            </div>
          </div>
        </div>

        <!-- Check-in / Check-out -->
        <div class="grid grid-cols-2 border-t border-slate-100">
          <div class="p-4">
            <div class="flex items-center gap-1 mb-1">
              <span class="material-symbols-outlined text-[13px] text-green-400">login</span>
              <span class="text-[11px] text-slate-400">{{ 'เช็คอิน' | translate : 'booking-info' }}</span>
            </div>
            <div class="text-sm font-semibold text-slate-800">{{bookingData().checkIn | thaidate:'long'}}</div>
          </div>
          <div class="p-4 border-l border-slate-100">
            <div class="flex items-center gap-1 mb-1">
              <span class="material-symbols-outlined text-[13px] text-red-400">logout</span>
              <span class="text-[11px] text-slate-400">{{ 'เช็คเอาท์' | translate : 'booking-info' }}</span>
            </div>
            <div class="text-sm font-semibold text-slate-800">{{bookingData().checkOut | thaidate:'long'}}</div>
          </div>
        </div>

        <!-- Stay summary -->
        <div class="px-4 pb-4 border-t border-slate-100">
          <div class="mt-3 flex items-center gap-4 flex-wrap">
            <div class="flex items-center gap-1.5">
              <span class="material-symbols-outlined text-[15px] text-slate-400">nights_stay</span>
              <span class="text-xs text-slate-600 font-medium">{{ '{n} คืน' | translate : { module: 'booking-info', n: bookingData().totalNights } }}</span>
            </div>
            <div class="flex items-center gap-1.5">
              <span class="material-symbols-outlined text-[15px] text-slate-400">door_open</span>
              <span class="text-xs text-slate-600 font-medium">{{ '{n} ห้อง' | translate : { module: 'booking-info', n: bookingData().totalRooms } }}</span>
            </div>
            <div class="flex items-center gap-1.5">
              <span class="material-symbols-outlined text-[15px] text-slate-400">person</span>
              <span class="text-xs text-slate-600 font-medium">{{ 'ผู้ใหญ่ {n} ท่าน' | translate : { module: 'booking-info', n: bookingData().totalAdults } }}
                @if (bookingData().totalChildren > 0) {· {{ 'เด็ก {n} คน' | translate : { module: 'booking-info', n: bookingData().totalChildren } }}}
              </span>
            </div>
          </div>
          <div class="mt-2 space-y-1">
            @for (r of bookingData().selectedRooms; track $index) {
            <div class="flex items-center gap-1.5">
              <span class="w-1.5 h-1.5 rounded-full bg-blue-300 shrink-0"></span>
              <span class="text-xs text-slate-500">{{r.qty}}x {{r.roomName}}</span>
              <span class="text-[11px] text-slate-400">({{r.planName}})</span>
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Booker Info -->
      @if (customerInfo()) {
      <div class="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div class="p-4">
          <div class="flex items-center gap-2 mb-3">
            <div class="w-6 h-6 rounded-md bg-violet-50 flex items-center justify-center shrink-0">
              <span class="material-symbols-outlined text-violet-400 text-[14px]">person</span>
            </div>
            <div class="text-sm font-semibold text-slate-800">{{ 'ข้อมูลผู้จอง' | translate : 'booking-info' }}</div>
          </div>

          <div class="space-y-3">
            <!-- Row 1 -->
            <div class="grid grid-cols-2 gap-x-4">
              <div>
                <div class="text-[11px] text-slate-400 mb-0.5">{{ 'ชื่อผู้จอง' | translate : 'booking-info' }}</div>
                <div class="text-sm font-medium text-slate-800 break-words">{{customerInfo().name || '-'}}</div>
              </div>
              <div>
                <div class="text-[11px] text-slate-400 mb-0.5">{{ 'เบอร์โทรศัพท์' | translate : 'booking-info' }}</div>
                <div class="text-sm font-medium text-slate-800">{{customerInfo().phone || '-'}}</div>
              </div>
            </div>
            <!-- Email full width -->
            <div>
              <div class="text-[11px] text-slate-400 mb-0.5">{{ 'อีเมล' | translate : 'booking-info' }}</div>
              <div class="text-sm font-medium text-slate-800 break-all">{{customerInfo().email || '-'}}</div>
            </div>
            @if (customerInfo().notMainGuest && customerInfo().mainGuestName) {
            <div class="rounded-xl bg-violet-50 border border-violet-100 px-3 py-2.5">
              <div class="text-[11px] text-violet-400 mb-0.5">{{ 'ผู้เข้าพักหลัก' | translate : 'booking-info' }}</div>
              <div class="text-sm font-semibold text-violet-800">{{customerInfo().mainGuestName}}</div>
            </div>
            }
          </div>
        </div>
      </div>
      }

      <!-- Payment Summary -->
      <div class="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <div class="p-4">
          <div class="flex items-center gap-2 mb-3">
            <div class="w-6 h-6 rounded-md bg-blue-50 flex items-center justify-center shrink-0">
              <span class="material-symbols-outlined text-blue-400 text-[14px]">receipt_long</span>
            </div>
            <div class="text-sm font-semibold text-slate-800">{{ 'สรุปค่าใช้จ่าย' | translate : 'booking-info' }}</div>
          </div>

          <div class="space-y-2">
            @for (r of bookingData().selectedRooms; track $index) {
            <div class="flex items-start justify-between gap-3">
              <div class="min-w-0">
                <div class="text-xs font-semibold text-slate-700 leading-snug">{{r.qty}}x {{r.roomName}}</div>
                <div class="text-[11px] text-slate-400">{{r.planName}}</div>
              </div>
              <div class="text-xs font-medium text-slate-700 shrink-0">{{r.subtotal | number}} {{ 'บาท' | translate : 'booking-info' }}</div>
            </div>
            }
          </div>

          <div class="mt-3 pt-3 border-t border-slate-100 flex items-center justify-between">
            <div class="text-sm text-slate-600">{{ 'ยอดรวมทั้งหมด' | translate : 'booking-info' }}</div>
            <div class="text-base font-bold text-blue-600">{{bookingData().totalPrice | number}} <span
                class="text-sm font-medium text-slate-500">{{ 'บาท' | translate : 'booking-info' }}</span></div>
          </div>
        </div>
      </div>

      <!-- Notice -->
      <div class="rounded-2xl bg-amber-50 border border-amber-100 p-4">
        <div class="flex items-start gap-2">
          <span class="material-symbols-outlined text-amber-400 text-[18px] shrink-0 mt-0.5">info</span>
          <div class="text-xs leading-5 text-amber-700">
            {{ 'หลังจากยืนยันการจองแล้ว กรุณาชำระเงินมัดจำตามช่องทางที่กำหนด' | translate : 'booking-info' }}<br>
            {{ 'การเปลี่ยนแปลงหรือยกเลิกต้องผ่านที่พักเท่านั้น' | translate : 'booking-info' }}
          </div>
        </div>
      </div>

    </div>

    <!-- Bottom Bar -->
    <div
      class="absolute bottom-0 inset-x-0 bg-white/80 backdrop-blur-md border-t border-slate-100 p-5 z-20 shadow-[0_-10px_30px_rgba(0,0,0,0.05)]">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
            <span class="material-symbols-outlined text-blue-500 text-[16px]">hotel</span>
          </div>
          <div>
            <div class="text-[11px] text-slate-400 font-medium">{{ 'ห้องพัก {n} ห้อง' | translate : { module: 'booking-info', n: bookingData().totalRooms } }}</div>
            <div class="text-sm font-bold text-slate-800">{{ '{n} คืน' | translate : { module: 'booking-info', n: bookingData().totalNights } }}</div>
          </div>
        </div>
        <div class="text-right">
          <div class="text-[11px] text-slate-400 font-medium uppercase tracking-wider mb-0.5">{{ 'ยอดรวมทั้งหมด' | translate : 'booking-info' }}</div>
          <div class="text-lg font-black text-slate-900 leading-none">{{bookingData().totalPrice | number}} <span
              class="text-xs font-bold text-slate-500">{{ 'บาท' | translate : 'booking-info' }}</span></div>
        </div>
      </div>
      @if (confirmError()) {
      <div
        class="mb-3 rounded-xl bg-red-50 border border-red-200 px-3 py-2.5 text-xs text-red-600 flex items-center gap-2">
        <span class="material-symbols-outlined text-[15px] text-red-400 shrink-0">error</span>
        {{ confirmError() | translate : 'api' }}
      </div>
      }
      <button
        class="w-full rounded-2xl bg-gradient-to-r from-blue-600 to-indigo-600 py-3.5 text-sm font-bold text-white hover:from-blue-700 hover:to-indigo-700 active:scale-[0.98] transition-all shadow-md shadow-blue-300 disabled:opacity-60 disabled:cursor-not-allowed"
        [disabled]="confirmLoading()" (click)="confirmBooking()">
        @if (confirmLoading()) {
        <div class="flex items-center justify-center gap-2">
          <span class="material-symbols-outlined text-[18px] animate-spin">progress_activity</span>
          <span>{{ 'กำลังยืนยัน...' | translate : 'booking-info' }}</span>
        </div>
        } @else {
        <div class="flex items-center justify-center gap-1.5">
          {{ 'ยืนยันการจอง' | translate : 'booking-info' }}
          <span class="material-symbols-outlined" style="font-size:1.1rem">check_circle</span>
        </div>
        }
      </button>
    </div>

  </div>
</div>
}